import { Button, Tab } from "@chakra-ui/react";
import { AddEntityButton } from "features/entities/AddEntityButton";
import { EntitiesTableContent } from "features/entities/EntitiesTableContent";
import { AllocationRuleGraphsTableContent } from "features/fund-family/setup/fund-structure/AllocationRuleGraphsTableContent";
import { PermissionTypeEnum } from "gen/model/permissionTypeEnum";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { Restricted } from "shared/components/access/Restricted";
import PageContent from "shared/components/layout/PageContent";
import { PageHeader } from "shared/components/layout/PageHeader";
import { TableBox } from "shared/components/table/box/TableBox";
import { TableBoxHeader } from "shared/components/table/box/TableBoxHeader";
import { TableBoxTabs } from "shared/components/table/box/TableBoxTabs";
import { DataTableBoxActions } from "shared/components/table/data/DataTableBoxActions";
import { useRequiredStringParams } from "shared/hooks/useRequiredStringParams";
import { rootRoute } from "shared/navigation/Routes";
// using an enum for better readability, but chakra expects an index under the hood
enum FundStructureTabs {
  allocationRules = 0,
  entities = 1,
}

export const FundFamilySetupFundStructurePage: React.FC = () => {
  const { t } = useTranslation(["allocation", "common", "entity"]);
  const { fundFamilyId } = useRequiredStringParams();
  const [selectedTab, setSelectedTab] = useState<FundStructureTabs>(
    FundStructureTabs.allocationRules,
  );

  const navigate = useNavigate();

  const onClickCreate = () => {
    navigate(
      rootRoute({})
        .fundFamilies({})
        .fundFamily({ fundFamilyId })
        .setup({})
        .fundStructure({})
        .fundFamilySetupAllocationRuleGraphCreate({}).$,
    );
  };

  const tabContents = [
    <AllocationRuleGraphsTableContent
      key={FundStructureTabs.allocationRules}
    />,
    <EntitiesTableContent
      fundFamilyId={fundFamilyId}
      key={FundStructureTabs.entities}
    />,
  ];
  const headerContents = [
    <Button
      key={FundStructureTabs.allocationRules}
      size="xs"
      colorScheme="secondary"
      onClick={onClickCreate}
    >
      {t("allocation:graphTable.create")}
    </Button>,
    <AddEntityButton
      fundFamilyId={fundFamilyId}
      size="xs"
      key={FundStructureTabs.entities}
      colorScheme="secondary"
    />,
  ];
  return (
    <PageContent isFullHeight={true}>
      <PageHeader title={t("common:fundStructure")} />
      <TableBox>
        <TableBoxHeader>
          <TableBoxTabs index={selectedTab} onChange={setSelectedTab}>
            <Tab>{t("allocation:allocationRules")}</Tab>
            <Tab>{t("entity:entities")}</Tab>
          </TableBoxTabs>
          <DataTableBoxActions showColControl={false}>
            <Restricted permission={PermissionTypeEnum.config}>
              {headerContents[selectedTab]}
            </Restricted>
          </DataTableBoxActions>
        </TableBoxHeader>
        {tabContents[selectedTab]}
      </TableBox>
    </PageContent>
  );
};
